import React, { FC, FormEvent } from "react";

import { toast } from "react-toastify";

import {
  useInput,
  useApisAdminOperatorAuthenticatePasswordUpdate,
} from "~/hooks";

import { PartnerConsoleLayout } from "~/components/layouts";
import { SettingPassword } from "~/components/organisms";

export const PartnerConsolesSettingPasswordShow: FC = () => {
  const breadCrumbItems = [
    {
      label: "パートナー画面",
      href: "/partner_consoles",
    },
    {
      label: "パスワード編集",
      href: "/partner_consoles/setting/password",
    },
  ];

  const [{ value: password, onChange: onChangePassword }] = useInput("");
  const [
    { value: passwordConfirmation, onChange: onChangePasswordConfirmation },
  ] = useInput("");

  const { mutate, isLoading } =
    useApisAdminOperatorAuthenticatePasswordUpdate();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    mutate(
      {
        body: {
          password,
          passwordConfirmation,
        },
      },
      {
        onSuccess: (data) => {
          toast(data.message);
        },
        onError: () => {
          toast.error("更新に失敗しました");
        },
      },
    );
  };

  return (
    <PartnerConsoleLayout breadCrumbItems={breadCrumbItems}>
      <SettingPassword
        onSubmit={handleSubmit}
        onChangePassword={onChangePassword}
        onChangePasswordConfirmation={onChangePasswordConfirmation}
        isLoading={isLoading}
        className="mt-8"
      />
    </PartnerConsoleLayout>
  );
};
